import Vue from "vue";

export function render(el, component, props) {
  new Vue({
    el,
    render(h) {
      return h(component, { props });
    },
  });
}
